'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DragConfig = require('./DragConfig');

var _DragMomentumAnimator = require('./DragMomentumAnimator');

var _DragMomentumAnimator2 = _interopRequireDefault(_DragMomentumAnimator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var activeDraggables = [];
var DRAG_START_THRESHOLD = 3;

var Draggable = function () {
  function Draggable() {
    var _this = this;

    _classCallCheck(this, Draggable);

    this._config = {};
    this._isControlledByDraggable = false;

    this._onTouchStart = function (e) {
      if (_this._dragAnimator) {
        _this._dragAnimator.stop();
      }
      _this._isControlledByDraggable = true;
      _this._dragCaptured = false;
      // TODO: handle when already constrained
      _this._dragStart = Object.assign({}, _this._p);
      _this._touches = [];
      _this._addTouch(_this._getTouch(e));
      activeDraggables.push(_this);
      if (_this._onDragStart) {
        _this._onDragStart();
      }
    };

    this._onTouchMove = function (e) {
      var dragStart = _this._dragStart;
      if (!dragStart) {
        return;
      }
      var touch = _this._getTouch(e);
      var x = dragStart.x;
      if (_this._config.x) {
        x += touch.clientX - _this._touches[0].clientX;
      }
      var y = dragStart.y;
      if (_this._config.y) {
        y += touch.clientY - _this._touches[0].clientY;
      }
      _this._p = {
        x: (0, _DragConfig.constrain)(x, _this._config.x),
        y: (0, _DragConfig.constrain)(y, _this._config.y)
      };
      if (!_this._dragCaptured && (Math.abs(_this._p.x - dragStart.x) > DRAG_START_THRESHOLD || Math.abs(_this._p.y - dragStart.y) > DRAG_START_THRESHOLD)) {
        if (activeDraggables.length > 1) {
          // this draggable has captured the event. end other active listeners
          activeDraggables.forEach(function (draggable) {
            return draggable !== _this && draggable.end();
          });
        }
        _this._dragCaptured = true;
      }
      if (_this._dragCaptured) {
        _this._updater(_this._p);
      }
      _this._addTouch(touch);
    };

    this._onTouchEnd = function () {
      if (!_this._dragStart) {
        return;
      }
      _this._onDragRelease(_this._p);
      // splitting this allows clients to modify props on touchend
      window.requestAnimationFrame(_this._onTouchEndMotion);

      _this._dragStart = null;
      activeDraggables = activeDraggables.filter(function (d) {
        return d !== _this;
      });
    };

    this._getTouch = function (e) {
      if (e.type.indexOf('mouse') !== -1) {
        // $FlowAssert
        var mouseEvent = e;
        return { clientX: mouseEvent.clientX, clientY: mouseEvent.clientY };
      }
      // $FlowAssert
      var touchEvent = e;
      return touchEvent.touches[0];
    };

    this._onTouchEndMotion = function () {
      var momentumX = _this._config.x && _this._config.x.momentum === true;
      var momentumY = _this._config.y && _this._config.y.momentum === true;
      if (momentumX || momentumY) {
        var v = { x: 0, y: 0 };
        var lastTouch = _this._touches[_this._touches.length - 1];
        if (Date.now() - lastTouch.t < 50) {
          var secondToLastTouch = _this._touches[_this._touches.length - 2];
          var dt = (lastTouch.t - secondToLastTouch.t) / 1000;
          v = {
            x: (lastTouch.clientX - secondToLastTouch.clientX) / dt,
            y: (lastTouch.clientY - secondToLastTouch.clientY) / dt
          };
        }

        _this._dragAnimator = new _DragMomentumAnimator2.default(_this._config.x, _this._config.y);
        _this._dragAnimator.start(_this._p, v, _this._updater, _this._onMomentumEnd);
      } else {
        _this._isControlledByDraggable = false;
        _this._onDragEnd && _this._onDragEnd(_this._p);
      }
    };

    this._addTouch = function (touch) {
      _this._touches.push({
        clientX: touch.clientX,
        clientY: touch.clientY,
        t: Date.now()
      });
    };

    this._updater = function (p) {
      // reapply hard constraints here. motion might cause overshoot.
      _this._p = _this._applyHardConstraints(p);
      _this._layerUpdater(_this._p);
    };

    this._onMomentumEnd = function (p) {
      _this._isControlledByDraggable = false;
      // reapply hard constraints here. motion might cause overshoot.
      _this._onDragEnd(_this._applyHardConstraints(p));
    };

    this._applyHardConstraints = function (p) {
      return {
        x: (0, _DragConfig.constrainHardOnly)(p.x, _this._config.x),
        y: (0, _DragConfig.constrainHardOnly)(p.y, _this._config.y)
      };
    };
  }

  _createClass(Draggable, [{
    key: 'start',
    value: function start(layer, initialPoint, onDragStart, updater, onDragRelease, onDragEnd) {
      this._layer = layer;
      this._p = Object.assign({}, initialPoint);
      this._onDragStart = onDragStart;
      this._layerUpdater = updater;
      this._onDragRelease = onDragRelease;
      this._onDragEnd = onDragEnd;
      this._layer.addEventListener('touchstart', this._onTouchStart, false);
      this._layer.addEventListener('touchmove', this._onTouchMove, false);
      this._layer.addEventListener('touchend', this._onTouchEnd, false);
      this._layer.addEventListener('mousedown', this._onTouchStart, false);
      document.addEventListener('mousemove', this._onTouchMove, false);
      document.addEventListener('mouseup', this._onTouchEnd, false);
    }
  }, {
    key: 'setConfig',
    value: function setConfig(property, config) {
      this._config[property] = config;
    }
  }, {
    key: 'setPoint',
    value: function setPoint(p) {
      this._p = Object.assign({}, p);
    }
  }, {
    key: 'getPoint',
    value: function getPoint() {
      return this._p;
    }
  }, {
    key: 'isActive',
    value: function isActive() {
      return this._isControlledByDraggable;
    }
  }, {
    key: 'stop',
    value: function stop() {
      this._isControlledByDraggable = false;
      if (this._dragAnimator) {
        this._dragAnimator.stop();
      }
      this._layer.removeEventListener('touchstart', this._onTouchStart);
      this._layer.removeEventListener('touchmove', this._onTouchMove);
      this._layer.removeEventListener('touchend', this._onTouchEnd);
      this._layer.removeEventListener('mousedown', this._onTouchStart);
      document.removeEventListener('mousemove', this._onTouchMove);
      document.removeEventListener('mouseup', this._onTouchEnd);
    }
  }, {
    key: 'end',
    value: function end() {
      var _this2 = this;

      this._dragStart = null;
      this._isControlledByDraggable = false;
      activeDraggables = activeDraggables.filter(function (d) {
        return d !== _this2;
      });
    }
  }]);

  return Draggable;
}();

exports.default = Draggable;


//////////////////
// WEBPACK FOOTER
// ./~/buttery/lib/Draggable.js
// module id = 168
// module chunks = 0